import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import { Sticker } from 'shared/components/'
import './style.css'

export default class StickerGroup extends Component {
  static propTypes = {
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        object: PropTypes.shape({
          id: PropTypes.number.isRequired,
          company: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          image: PropTypes.string.isRequired
        }),
        object_type: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired
      })
    ),
    isContentCentered: PropTypes.bool,
    params: PropTypes.any
  }

  static defaultProps = {
    isContentCentered: false
  }

  render () {
    return (
      <div className={`row centered-content-container ${this.props.isContentCentered ? 'centered-sticker-group' : ''}`}>
        {sortBy(this.props.elements, 'order').map(element =>
          <div key={get(element.object, 'id')} className='col-md-3 col-sm-6 sticker-element'>
            <Sticker
              image={get(element.object, 'image')}
              name={get(element.object, 'name')}
              params={this.props.params}
              objectId={get(element.object, 'id')}
              objectName={get(element.object, 'name')}
              objectType={element.object_type} />
          </div>
        )}
      </div>
    )
  }
}
